{
  "version": 1,
  "asset_id": "5259faa9-99db-4a56-8f55-952bd7322235",
  "project_id": "1c7313b7-7160-4256-be8b-cc48c05288da",
  "url": "/__l5e/assets-v1/5259faa9-99db-4a56-8f55-952bd7322235/cert-receita.svg",
  "r2_key": "a/v1/1c7313b7-7160-4256-be8b-cc48c05288da/5259faa9-99db-4a56-8f55-952bd7322235/cert-receita.svg",
  "original_filename": "cert-receita.svg",
  "size": 13271,
  "content_type": "image/svg+xml",
  "created_at": "2026-09-22T12:21:21Z"
}
